import cookie from 'js-cookie';
import initialFeedCookie from '../constants/initialFeedCookie';

export default (value?: number) => {
  cookie.set(initialFeedCookie, String(value));
};
